// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"0801fd57","73":"1459712d","152":"a20bbcb5","236":"0de2c19f","247":"19e7b0f9","280":"bec74648","654":"33cb550f","915":"403491aa"}[chunkId] + ".css";
};